import type { ReactNode } from 'react'

/** Empty state copy inside a `SettingsPanel`. */
export function SettingsPanelEmpty({ children }: { children: ReactNode }) {
  return (
    <div className="px-4">
      <p className="min-h-16 py-4 text-sm text-muted-foreground">{children}</p>
    </div>
  )
}
